module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-row', {
    staticClass: "gPageBorder  gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_cardno')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.accountNo) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_trdno')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.traceId) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_batcno')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.batchId) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_amout')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.amout) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_mechno')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.merchId) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_no')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.terminalNo) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_trdtime')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.requesTime) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_trddate')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.requestDate) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_trdcore')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.hostagentserialNo) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_expno')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.referenceNo) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_license')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.authRc) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_trdtype')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.transType) + "\n        ")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_rectime')
    }
  }, [_vm._v("\n          " + _vm._s(_vm.detail.recordTime) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg gPdTB"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_fpaddrs')) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.$host + _vm.detail.faceUrl
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b4e1673"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/terminal/trDetail.vue
// module id = 1015
// module chunks = 0